import { CartItem, CartItemsPayment, Orders, PaymentMethod } from '@/types/cart.type'
import { PaymentCode } from '@/types/enum'

export const getPrice = (cartItem: CartItem, quantity: number) => {
  for (let i = cartItem.prices.length - 1; i >= 0; i--) {
    if (quantity >= cartItem.prices[i].quantity) {
      return cartItem.prices[i]
    }
  }

  return null // Trường hợp input nhỏ hơn giá trị đầu tiên trong mảng
}

export const updatePriceField = (carts: CartItem[], isEn: boolean, increasePrice = 1): CartItem[] => {
  return carts.map((item) => {
    // Xử lý trường hợp prices rỗng
    if (!item.prices || item.prices.length === 0) {
      return {
        ...item,
        price: 0,
        totalPrice: 0,
      }
    }

    if (!item.minimum_order_quantity) {
      if (item.multiples) {
        item.minimum_order_quantity = item.multiples
      } else {
        item.minimum_order_quantity = 1
      }
    }
    if (!item.quantity) {
      item.quantity = 0
    }

    // Tìm giá phù hợp
    const matchedPrice = getPrice(item, item.quantity)

    if (!matchedPrice) {
      return {
        ...item,
        price: 0,
        totalPrice: 0,
      }
    }

    // Tính toán giá dựa trên điều kiện
    const price = isEn
      ? Math.round(+matchedPrice.price * 1000) / 1000 // Làm tròn đến 3 chữ số thập phân
      : Math.floor(+matchedPrice.price * increasePrice)

    return {
      ...item,
      price: price,
      totalPrice: price * item.quantity,
    }
  })
}

export const calculateTotal = (carts: CartItem[]): number => {
  return carts.reduce((acc: any, cur: any) => acc + (cur.totalPrice ?? 0), 0)
}

export const calculateActualAmount = (carts: CartItem[]): number => {
  const { total, extraMoney } = carts.reduce(
    (acc, cart) => {
      if (cart.isCheck) {
        acc.total += cart.totalPrice

        if (cart.show_category_extra && cart.category_extra_id && cart.category_extras?.length > 0) {
          const categoryExtra = cart.category_extras?.find((ce) => ce.id === cart.category_extra_id)
          acc.extraMoney += categoryExtra?.price ?? 0
        }
      }
      return acc
    },
    { total: 0, extraMoney: 0 },
  )

  const actualAmount = total + extraMoney

  return Math.round(actualAmount * 1000) / 1000 // Làm tròn đến 3 chữ số thập phân
}

export const cartItemsPayment = (carts: CartItem[]): CartItemsPayment[] => {
  return carts
    .filter((cart) => cart.isCheck) // Lọc các cart được chọn (isCheck === true)
    .map((cart) => ({
      product_id: cart.id,
      price: cart.price,
      quantity: cart.quantity,
      category_extra_id: cart.category_extra_id,
    }))
}

export const calculateTransactionFee = (paymentMethods: PaymentMethod[], order: Orders, cartItems: CartItem[], vatData?: any): number => {
  if (![PaymentCode.momo, PaymentCode.vnpay, PaymentCode.paypal].includes(order?.payment_code as PaymentCode)) {
    return order?.transaction_fee ?? 0
  } else {
    if (vatData && vatData?.vat_value?.vat === 1) {
      const increasePrice = vatData.increase_price ? 1 + +vatData.increase_price / 100 : 1
      const vat = vatData.vat ? +vatData.vat : 0

      const actualAmount = calculateActualAmount(updatePriceField(cartItems, Boolean(order.delivery_global_id) == true, increasePrice))
      const payment = paymentMethods.find((pm) => pm.id === order?.payment_method_id)

      const percent = payment?.payment_fee_percent ? payment.payment_fee_percent / 100 : 1
      const transportFee = order?.transport_fee ?? 0
      const paymentFee = payment?.payment_fee ?? 0
      const taxFee = Math.round((actualAmount + transportFee) * vat)

      return (transportFee + actualAmount + taxFee) * percent + paymentFee
    } else {
      const actualAmount = calculateActualAmount(cartItems)
      const payment = paymentMethods.find((pm) => pm.id === order?.payment_method_id)

      const percent = payment?.payment_fee_percent ? payment.payment_fee_percent / 100 : 1
      const transportFee = order?.transport_fee ?? 0
      const paymentFee = payment?.payment_fee ?? 0

      return (transportFee + actualAmount) * percent + paymentFee
    }
  }
}
